<template>
  <div class="overflow-hidden relative">
    <!-- Wrapper -->
    <div
      class="flex transition-transform duration-700 ease-in-out"
      :style="{ transform: `translateX(-${currentIndex * 100}%)` }"
    >
      <div v-for="(slide, index) in slides" :key="index" class="min-w-full">
        <img
          :src="slide"
          class="w-full h-[calc(100vh-120px)] object-cover object-center"
          alt="slide image"
        />
      </div>
    </div>

    <!-- Indikator -->
    <div class="absolute bottom-5 left-1/2 -translate-x-1/2 flex space-x-2">
      <button
        v-for="(dot, i) in slides.length"
        :key="i"
        @click="goToSlide(i)"
        class="h-1 w-8 transition-all duration-300"
        :class="i === currentIndex ? 'bg-white/90 w-8' : 'bg-white/40 w-4'"
      ></button>
    </div>
  </div>
</template>

<script>
import img1 from "@/assets/images/carousel_1.png";
import img2 from "@/assets/images/carousel_2.png";
import img3 from "@/assets/images/carousel_3.png";
import img4 from "@/assets/images/carousel_4.png";
import img5 from "@/assets/images/carousel_5.jpg";

export default {
  name: "CarouselComponent",
  data() {
    return {
      slides: [img1, img2, img3, img4, img5],
      currentIndex: 0,
      intervalId: null,
    };
  },
  methods: {
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.slides.length;
    },
    prevSlide() {
      this.currentIndex =
        (this.currentIndex - 1 + this.slides.length) % this.slides.length;
    },
    goToSlide(index) {
      this.currentIndex = index;
    },
  },
  mounted() {
    // Auto-slide setiap 3 detik
    this.intervalId = setInterval(() => {
      this.nextSlide();
    }, 3000);
  },
  beforeUnmount() {
    clearInterval(this.intervalId);
  },
};
</script>
